/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Bell140 = (props: SVGProps) => (
    <AccessibleSVG width={140} height={140} viewBox="0 0 140 140" {...props}>
        <g fill="none" fillRule="evenodd" transform="translate(0 26)">
            <path
                fill={vars.bdlBoxBlue}
                fillOpacity={0.07}
                d="M40.585 56.757c1.054 0 1.909.858 1.909 1.918v9.548a1.92 1.92 0 01-1.909 1.918H6.443a1.912 1.912 0 01-1.908-1.918v-9.548a1.92 1.92 0 011.908-1.918h34.142zm42-.033c1.054 0 1.909.857 1.909 1.917v9.549a1.92 1.92 0 01-1.909 1.917H48.443a1.912 1.912 0 01-1.908-1.917v-9.55a1.92 1.92 0 011.908-1.917h34.142zm20.645 0c1.059 0 1.918.857 1.918 1.917v9.549a1.917 1.917 0 01-1.918 1.917H89.76a1.917 1.917 0 01-1.917-1.917v-9.55c0-1.059.858-1.917 1.918-1.917h13.469zM19.928 40.229c1.056 0 1.912.857 1.912 1.917v9.549a1.913 1.913 0 01-1.912 1.917H1.992a1.914 1.914 0 01-1.911-1.917v-9.549c0-1.059.853-1.917 1.911-1.917h17.936zm42.294 0c1.054 0 1.908.857 1.908 1.917v9.549a1.92 1.92 0 01-1.908 1.917H28.08a1.912 1.912 0 01-1.909-1.917v-9.549a1.92 1.92 0 011.909-1.917h34.142zm41.017-.235c1.054 0 1.909.858 1.909 1.918v9.548a1.92 1.92 0 01-1.909 1.918H69.097a1.912 1.912 0 01-1.908-1.918v-9.548a1.92 1.92 0 011.908-1.918h34.142zM82.585 23.265c1.054 0 1.909.858 1.909 1.918v9.548a1.92 1.92 0 01-1.909 1.917H48.443a1.912 1.912 0 01-1.908-1.917v-9.548a1.92 1.92 0 011.908-1.918h34.142zm20.645 0c1.059 0 1.918.858 1.918 1.918v9.548a1.917 1.917 0 01-1.918 1.917H89.76a1.917 1.917 0 01-1.917-1.917v-9.548c0-1.06.858-1.918 1.918-1.918h13.469zm-62.645-.2c1.054 0 1.909.857 1.909 1.917v9.548a1.92 1.92 0 01-1.909 1.918H6.443a1.912 1.912 0 01-1.908-1.918v-9.548a1.92 1.92 0 011.908-1.918h34.142zm21.346-16.53c1.054 0 1.909.858 1.909 1.918v9.549a1.92 1.92 0 01-1.909 1.917H27.79a1.912 1.912 0 01-1.909-1.917V8.453a1.92 1.92 0 011.909-1.917h34.14zm-42.003 0c1.056 0 1.912.858 1.912 1.918v9.549a1.913 1.913 0 01-1.912 1.917H1.992a1.914 1.914 0 01-1.911-1.917V8.453c0-1.059.853-1.917 1.911-1.917h17.936zm83.311 0c1.054 0 1.909.858 1.909 1.918v9.549a1.92 1.92 0 01-1.909 1.917H69.097a1.912 1.912 0 01-1.908-1.917V8.453a1.92 1.92 0 011.908-1.917h34.142z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M39.482 83.548a.75.75 0 011.016.304c.623 1.155.705 1.177 1.196.805.076-.058.1-.077.304-.244.692-.564 1.097-.795 1.724-.795.843 0 1.33.245 1.935.793l.069.062c.282.256.392.32.609.339a.75.75 0 11-.128 1.494c-.619-.053-.985-.265-1.489-.722l-.068-.062c-.355-.321-.52-.404-.928-.404-.156 0-.35.11-.776.458-.223.182-.249.203-.346.277-1.256.952-2.38.644-3.422-1.289a.75.75 0 01.304-1.016zm46.647.24a.75.75 0 011.243.84c-.151.224-.413.53-.782.836-.688.569-1.492.9-2.395.843-.724-.045-1.162-.23-1.797-.654l-.094-.062c-.54-.36-.849-.473-1.535-.473-.355 0-.67.131-1.319.52-.3.18-.336.201-.464.272-1.516.844-2.754.595-4.116-1.258a.75.75 0 111.209-.888c.908 1.235 1.313 1.317 2.178.836.108-.06.14-.08.423-.249.873-.523 1.376-.733 2.089-.733 1.018 0 1.599.214 2.366.724l.094.063c.435.29.647.38 1.06.405.474.03.926-.156 1.345-.502.245-.203.417-.405.495-.52zm38.094-79.524a1 1 0 110 2h-14.628a.91.91 0 00-.913.908v73.742c0 .498.41.907.913.907h20.991a1 1 0 010 2h-20.99a2.913 2.913 0 01-2.914-2.907V7.172a2.91 2.91 0 012.913-2.908zm13.686 77.556a1 1 0 110 2h-2.545a1 1 0 010-2zm-.954-14.691a1 1 0 110 2h-15.273a1 1 0 110-2zm-8.91-12.5a1 1 0 010 2h-10.181a1 1 0 010-2zm10.455-12.5a1 1 0 110 2h-15.273a1 1 0 110-2zm-9.182-13a1 1 0 110 2h-11.454a1 1 0 010-2zm5.091-11.5a1 1 0 110 2h-14a1 1 0 110-2zm1.273-13.369a1 1 0 110 2h-6.364a1 1 0 110-2z"
            />
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeWidth={1.5}
                d="M93.045 82.55a1.908 1.908 0 11.002 3.816 1.908 1.908 0 01-.002-3.816zm-59.181 0a1.908 1.908 0 11.002 3.816 1.908 1.908 0 01-.002-3.816z"
            />
            <path
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M73.204 51.003c5.82 29.801-24.11 20.785-24.11 20.785l5.236 7.22m29.822-47.432c7.32 14.279 20.754.53 21.783-1.32 1.03-1.848-.623-4.649-.623-4.649"
            />
            <path
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M63.217 51.671c-6.703 16.493 1.7 31.006 1.7 31.006l-8.78.86m-5.16-54.638C40.187 39.312 52.094 59.3 52.094 59.3"
            />
            <ellipse
                cx={76.864}
                cy={3.906}
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeWidth={2}
                rx={2.545}
                ry={2.543}
                transform="rotate(10 76.864 3.906)"
            />
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M74.894 5.173c10.383 1.83 17.17 12.565 15.158 23.975-.049.276-.102.55-.16.823l-.006.032c-.112.674-1.9 11.517-1.456 15.672.458 4.29 6.343 5.303 5.625 9.37-.717 4.067-4.067 3.785-4.067 3.785l-47.63-8.398s-3.058-.704-2.316-4.911c.741-4.208 6.194-3.128 8.329-6.91 1.851-3.28 3.478-12.352 3.877-14.7.052-.462.12-.927.202-1.393 2.012-11.41 12.06-19.176 22.444-17.345z"
            />
            <path
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M82.496 16.562s1.378 1.655 2.419 4.136c1.04 2.48.98 4.47.98 4.47"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillOpacity={0.07}
                d="M42.74 46.161c.394-2.237 4.956-1.926 6.622-3.843 4.456 2.35 12.182 1.219 16.672 5.54 4.49 4.32 11.475-1.54 20.727 1.055.683 2.358 5.324 3.72 4.942 5.882-.38 2.162-2.135 1.46-2.135 1.46l-45.61-8.042s-1.612.185-1.218-2.052z"
            />
        </g>
    </AccessibleSVG>
);

export default Bell140;
